import { browser } from './_browser-version'

window.addEventListener('load', load_mobile_menu)
window.addEventListener('resize', load_mobile_menu)
//console.log('what is window outer width?', window.outerWidth)

async function load_mobile_menu() {
	if (1023 >= window.innerWidth && browser.name !== 'ie') {
		window.removeEventListener('load', load_mobile_menu)
		window.removeEventListener('resize', load_mobile_menu)

		const menu_module = await import(/* webpackChunkName: "mobile-menu" */ 'mmenu-js')
		const Mmenu = menu_module.default

		const menu = new Mmenu('#mobile_menu_js', {
			counters: {
				add: false,
			},
			extensions: ['position-right'],
		})

		const api = menu.API

		document.getElementById('main_menu_toggle_js').addEventListener('click', event => {
			event.preventDefault()

			api.open()
		})

		document.getElementById('mm-0').addEventListener('click', event => {
			event.preventDefault()

			api.close()
		})

		document.getElementById('mobile_menu_js').classList.remove('hidden')

		//grab the quick links menu items and add them to the mobile menu
		const quickLinksListItems = document.querySelectorAll('#menu-quick-links li')
		const mobileMenu = document.getElementsByClassName('mm-listview')

		if (quickLinksListItems && mobileMenu) {
			for (let i = 0; i < quickLinksListItems.length; i++) {
				//console.log(quickLinksListItems[i])

				quickLinksListItems[i].classList.add('mobile-quicklink')

				//append this li to the ul
				mobileMenu[0].appendChild(quickLinksListItems[i])
			}
		}
	}
}
